export const TransferRequestStatusEnum = {
  Draft: 'Draft',
  WaitingForApproval: 'WaitingForApproval',
  Completed: 'Completed',
  Scheduled: 'Scheduled',
  Cancelled: 'Cancelled',
} as const;
export type TransferRequestStatusEnum = (typeof TransferRequestStatusEnum)[keyof typeof TransferRequestStatusEnum];
